import { IAppState } from '../../redux';

export const selectSubagentSpendLimit = (state: IAppState): number => {
  return state.user.limitedBalance || 0;
};
